"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";

const LandingPage = () => {
  const router = useRouter();

  useEffect(() => {
    router.push("/login");
  }, [router]);

  return null; // Tidak perlu merender apa pun karena pengguna langsung diarahkan
};

export default LandingPage;
